import { DocumentTypesEnum } from '@thinknet-gmbh/platform-common';

export const DOCUMENTS_LIST_MODALS = {
  deleteTemplate: 'deleteTemplate',
  previewTemplate: 'previewTemplate',
};

export const FILETYPES = {
  [DocumentTypesEnum.DOC]: 'msword',
  [DocumentTypesEnum.PDF]: 'pdf',
};
